// extracted by mini-css-extract-plugin
export default {"scrollbtn":"Scrollbtn_scrollbtn__h--XF"};